import React from 'react';
import SectionLabel from '../ui/SectionLabel';
import './HowItWorksSection.css';

const steps = [
  {
    number: '01',
    icon: '🏡',
    title: 'Create Your Farm Profile',
    description:
      'Set up your personal farm in seconds. Add your farm name and start your livestock journey with Dhenika.',
  },
  {
    number: '02',
    icon: '🐄',
    title: 'Add Your Animals',
    description:
      'Add each animal with their name, breed, age and photo. Build a complete profile for every cow or pet you own.',
  },
  {
    number: '03',
    icon: '📋',
    title: 'Log Health & Records',
    description:
      'Record vaccinations, medical visits, deworming and breeding details — all saved securely in one place.',
  },
  {
    number: '04',
    icon: '🔔',
    title: 'Get Smart Reminders',
    description:
      'Dhenika alerts you before due dates for vaccines, checkups and breeding — so nothing is ever missed.',
  },
];

function HowItWorksSection() {
  return (
    <section className="hiw" id="how-it-works">
      <div className="hiw__container">

        {/* ── Header ── */}
        <div className="hiw__header">
          <SectionLabel text="⚙️ How It Works" />
          <h2 className="hiw__heading">
            Up and running in{' '}
            <span className="hiw__heading--accent">4 simple steps.</span>
          </h2>
          <p className="hiw__subtext">
            No training needed. Dhenika is built for every Indian farmer —
            simple, fast and works in your language.
          </p>
        </div>

        {/* ── Steps ── */}
        <div className="hiw__steps">
          {steps.map((step, index) => (
            <div className="hiw__step" key={step.number}>

              {/* connector line (not on last) */}
              {index < steps.length - 1 && (
                <div className="hiw__connector" aria-hidden="true" />
              )}

              <div className="hiw__step-num">{step.number}</div>

              <div className="hiw__step-icon" aria-hidden="true">
                {step.icon}
              </div>

              <div className="hiw__step-body">
                <h3 className="hiw__step-title">{step.title}</h3>
                <p className="hiw__step-desc">{step.description}</p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default HowItWorksSection;